var Choices = require('choices.js');

export default function Dropdown() {
  var ch = this;

  function _init() {
    _setup(document);
  }

  function _setup(scope) {
    if (scope.querySelectorAll('[data-choices]').length < 1) {
      return;
    }



    let formElements = scope.querySelectorAll('[data-choices]'),
      i;

    for (i = 0; i < formElements.length; i++) {
      attachChoices(formElements[i]);
    }

    applyLabels();
  }

  function attachChoices(element) {
    let config = getChoicesConfig(element),
      choices = new Choices(element, config);

    attachAutoClose(choices, element);
    attachSetValue(choices, element);
  }

  function getChoicesConfig(element) {
    let placeholder = element.getAttribute('placeholder') ? element.getAttribute('placeholder') : null,
      hasSearch = (element.dataset.search || element.dataset['has-search']) ? true : false,
      maxitems = element.dataset['choices-maxitemcount'] || -1,
      removeItems = (element.dataset.canremove || element.dataset['canremove']) ? true : false;

    return {
      silent: false,
      items: [],
      choices: [],
      renderChoiceLimit: -1,
      maxItemCount: maxitems,
      addItems: true,
      removeItems: removeItems,
      removeItemButton: removeItems,
      editItems: false,
      duplicateItemsAllowed: true,
      delimiter: ',',
      paste: true,
      searchEnabled: hasSearch,
      searchChoices: true,
      searchFloor: 3,
      searchResultLimit: 10,
      searchFields: ['label', 'value'],
      position: 'auto',
      resetScrollPosition: true,
      shouldSort: false,
      shouldSortItems: false,
      placeholder: true,
      placeholderValue: placeholder,
      searchPlaceholderValue: null,
      prependValue: null,
      appendValue: null,
      renderSelectedChoices: 'auto',
      loadingText: 'Loading...',
      noResultsText: 'No results found',
      noChoicesText: '',
      itemSelectText: ''
    };
  }

  function attachAutoClose(choices, element) {
    element.addEventListener('choice', function (e) {
      choices.hideDropdown();
    }, false);
  }

  function attachSetValue(choices, element) {
    element.addEventListener('setValue', function (event) {
      choices.setChoiceByValue(event.detail);
    }, false);
  }

  function applyLabels() {
    let labelledSelects = document.querySelectorAll('select[aria-labelledby]'); // may need to exclude some formelements

    if (labelledSelects.length > 0) {
      labelledSelects.forEach(function () {
        let select = this,
          label = select.attr('aria-labelledby');

        select.siblings('input').attr('aria-labelledby', label).attr('role', 'combobox');
        select.closest('.choices').find('[role="listbox"]').attr('aria-labelledby', label);
      });
    }
  }

  ch.start = () => {
    _init();
  };

  ch.setValue = (element, value) => {
    const setValueEvent = new CustomEvent('setValue', { 'detail': value });
    element.dispatchEvent(setValueEvent);
  };

  return ch;
}
